import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { City, State } from '@voice/utils';

@Injectable({ providedIn: 'root' })
export class GeographyService {
  constructor(private http: HttpClient) {}

  public getStates(): Observable<State[]> {
    const url = `${environment.voiceAPIConfig.uri}/geography/states`;
    return this.http.get<State[]>(url);
  }

  public getCities(stateId: string): Observable<City[]> {
    const url = `${environment.voiceAPIConfig.uri}/geography/states/${stateId}/cities`;
    return this.http.get<State[]>(url);
  }
}
